import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid, formValueSelector } from 'redux-form'
import { debounce } from '../../../../../helpers/debounce'
import * as actions from '../../../actions'
import CamposProcesoCalado1 from '../../../components/proceso/CamposProcesoCalado1'
import { FORM_PROCESO_CALADO } from '../../../../../config/forms'
import StatusModal from '../../../../Forms/SharedComponents/containers/StatusModal'
import CpaInfo from '../../../components/CpaInfo'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { mensajeUsuario, mensajeContexto } from '../../../../../helpers/message'
import { INTERVALO_EXTRA_LARGO } from '../../../../../config/settings'
import { cerealesColor } from '../../../../../config/cereales'
import { IsJsonString } from '../../../../../helpers/json'
import { toast } from 'react-toastify'
import { Button } from '@material-ui/core'
import { COLORES } from '../../../../../config/colores'

const selector = formValueSelector(FORM_PROCESO_CALADO)

class ProcesoCalado1 extends Component {
  constructor (props) {
    super(props)
    this.interval = 0
    this.hideValidacionModal = this.hideValidacionModal.bind(this)
    this.handleCondicionChange = this.handleCondicionChange.bind(this)
    this.consultaEstadoOcupacionCallesCalado = this.consultaEstadoOcupacionCallesCalado.bind(this)
    this.onChangeDisplay = this.onChangeDisplay.bind(this)
    this.state = { cpeLeida: '' }
  }

  hideValidacionModal () {
    this.props.hideSaveCaladoModal()
  }

  componentDidMount () {
    const {
      cpe,
      cpa,
      cea,
      requestCalleSugerida,
      change: formChange
    } = this.props

    if (!cpa.fechaDeEgresoPlaya) {
      toast.error('La Carta de Porte no tiene egreso de playa', { autoClose: false })
    }

    this.consultaEstadoOcupacionCallesCalado()
    this.consultaCalificacionPorCalleCalado()

    this.intervalCalle = setInterval(() => {
      if (!this.props.isOpenBarchar) {
        debounce(this.consultaCalificacionPorCalleCalado(), 300)
        debounce(this.consultaEstadoOcupacionCallesCalado(), 300)
      }
    }, INTERVALO_EXTRA_LARGO)

    const claveCereal = cea.claveCereal || cpa.claveCereal
    requestCalleSugerida(claveCereal, (calle) => {
      formChange('calle', calle && calle.numero)
    })

    this.intervalEstadoCalle = setInterval(() => {
      const { puestoCalado } = this.props
      let c
      if (puestoCalado === 'calle_1-2') {
        c = (cpe.calleDeIngreso === 1) ? 2 : 1
      } else {
        c = (cpe.calleDeIngreso === 3) ? 4 : 3
      }
      this.props.getEstadoCalle(c)
    }, 5000)

    // this.intervalSonda = setInterval(() => {
    //   console.log('Tiene que entrar solo si esta nulo --->', lecturaAnalisisSonda)
    //   if (!lecturaAnalisisSonda) {
    //     this.props.obtenerAnalisisSonda(numero)
    //     console.log('obteniendo lectura de sonda nuevamente', lecturaAnalisisSonda)
    //   }
    // }, INTERVALO_EXTRA_LARGO)
    // // Verificar estructura de lectura de json
    // if (lecturaAnalisisSonda) this.verificarAnalisisSonda(lecturaAnalisisSonda)
  }

  // componentDidUpdate (prevProps) {
  //   if (this.props.lecturaAnalisisSonda === prevProps.lecturaAnalisisSonda) {
  //     if (this.intervalSonda) clearInterval(this.intervalSonda)
  //     console.log('Se limpia el intervalo de lectura de la sonda')
  //   } else {
  //     // Verificar estructura de lectura del json
  //     this.verificarAnalisisSonda(this.props.lecturaAnalisisSonda)
  //   }
  // }

  componentWillUnmount () {
    clearInterval(this.intervalOcupacion)
    clearInterval(this.intervalCalle)
    clearInterval(this.intervalEstadoCalle)
    // clearInterval(this.intervalSonda)
  }

  handleCondicionChange (modo) {
    if (modo === 'A') {
      this.props.change('condicionIngreso', null)
      this.props.change('condicionIngresoSegunda', null)
    }
  }

  consultaCalificacionPorCalleCalado () {
    this.props.consultaCalificacionPorCalleCalado()
  }

  consultaEstadoOcupacionCallesCalado () {
    this.props.consultaEstadoOcupacionCallesCalado()
  }

  onChangeDisplay (e) {
    // guardar el estado del display modificado
    if (e.target.value > 0) {
      console.log(e.target.value)
      this.props.actualizarDisplaySugerido(e.target.value)
    }
  }

  /* // verificarAnalisisSonda (lecturaAnalisisSonda) {
  //   let franja2 = true; let franja3 = true; let franja4 = true
  //   if (lecturaAnalisisSonda && lecturaAnalisisSonda !== null) {
  //     for (const i in lecturaAnalisisSonda.Mediciones) {
  //       for (const j in lecturaAnalisisSonda.Mediciones[i].Medicion) {
  //         if (lecturaAnalisisSonda.Mediciones[i].Medicion[j].nombre === 'HUMEDAD') {
  //           console.log('lectura', lecturaAnalisisSonda.Mediciones[i].Medicion[j].valor)
  //           if (lecturaAnalisisSonda.Mediciones[i].Medicion[j].franja === '2') franja2 = false
  //           if (lecturaAnalisisSonda.Mediciones[i].Medicion[j].franja === '3') franja3 = false
  //           if (lecturaAnalisisSonda.Mediciones[i].Medicion[j].franja === '4') franja4 = false
  //         }
  //       }
  //       if (franja2) lecturaAnalisisSonda.Mediciones[i].Medicion.push({ nombre: 'HUMEDAD', valor: '0', franja: '2' })
  //       if (franja3) lecturaAnalisisSonda.Mediciones[i].Medicion.push({ nombre: 'HUMEDAD', valor: '0', franja: '3' })
  //       if (franja4) lecturaAnalisisSonda.Mediciones[i].Medicion.push({ nombre: 'HUMEDAD', valor: '0', franja: '4' })
  //       franja2 = true
  //       franja3 = true
  //       franja4 = true
  //     }
  //   }
  // } */

  render () {
    const {
      handleSubmit,
      onPrev,
      cpa,
      cpe,
      cea,
      modoIngreso,
      caladoShowSaveModal,
      caladoSaveResponse,
      estadoOcupacionCallesCalado,
      calificacionPorCalleCalado,
      lecturaAnalisisSonda,
      cerealEspecie,
      openDialogKeyboard,
      cpeEnPreingreso1,
      cpeEnPreingreso2,
      cpeEnPreingreso3,
      cpeEnPreingreso4
    } = this.props

    var data = []
    const generarData = (estadoOcupacionCallesCalado) => {
      estadoOcupacionCallesCalado.filas.forEach((calle) => {
        data.push([
          `C${calle.calleDeCalado}`,
          calle.ocupado,
          (calle.cerealAsignado != null) ? cerealesColor[`${calle.cerealAsignado.trim()}`] : '#e0e0e0',
          // ((calle.capacidad - calle.ocupado) < 0) ? 0 : (calle.capacidad - calle.ocupado),
          // '#e0e0e0',
          `${calle.capacidad}`,
          `${calle.cerealAsignado}`,
          `Calle ${calle.calleDeCalado}-Capacidad ${calle.capacidad}-Usado ${calle.ocupado}-Cereal ${calle.cerealAsignado}`,
          calle.ordenDeSalida
        ])
      })
    }
    if (estadoOcupacionCallesCalado !== null && estadoOcupacionCallesCalado.filas_procesadas > 0) {
      if (estadoOcupacionCallesCalado.estado === 'exito') {
        generarData(estadoOcupacionCallesCalado)
      }
    }

    const generarHumedades = (lecturaAnalisisSonda) => {
      return lecturaAnalisisSonda.Mediciones.map(
        ({ Medicion }) => Medicion
          .filter(({ nombre }) => nombre === 'HUMEDAD')
          .filter(({ franja }) => franja !== '6')
          .filter(({ valor }) => valor > 0)
          .reduce((acc, { valor }) => [...acc, Math.round(parseFloat(valor) * 10) / 10], [])
      ).flat()
    }

    var humedades = (lecturaAnalisisSonda !== ']}]}' && lecturaAnalisisSonda !== null && IsJsonString(lecturaAnalisisSonda))
      ? generarHumedades(lecturaAnalisisSonda) : null
    var maxH = (humedades !== null) ? Math.max(...humedades) : 0
    var minH = (humedades !== null) ? Math.min(...humedades) : 0
    // var avgH = (humedades.reduce((a, b) => a + b, 0) / humedades.length).toFixed(2)
    var avgH = (humedades !== null)
      ? Math.round((humedades.reduce((a, b) => a + b, 0) / humedades.length) * 10) / 10 : 0

    // console.log('Las Humedades', humedades)
    // console.log('El maximo', maxH)
    // console.log('El minimo', minH)
    // console.log('El promedio', avgH)

    const generarDataAnalisis = (lecturaAnalisisSonda) => {
      this.verificarAnalisisSonda(lecturaAnalisisSonda)
      console.log('Inicio de generacion de datos para el grafico...')
      return lecturaAnalisisSonda.Mediciones.map(({ Medicion, Calada }) => [
        Calada,
        ...Medicion.reduce(
          (acc, { valor, franja, nombre }) => {
            if (nombre !== 'HUMEDAD') return acc
            if (franja === '6') return acc

            let index = 0
            if (franja === '3') { index = 1 } else if (franja === '4') { index = 2 }

            acc[index] = valor
            // console.log (acc)
            return acc
          },
          []
        ).map((humedad, index) => [10, obtenerColor(humedad), Math.round(parseFloat(humedad) * 10) / 10]).flat()
      ])
    }

    const obtenerColor = (valor, color = null) => {
      const humedadBase = cerealEspecie['limiteDeHumedad'];
      (valor < (humedadBase - 0.5)) ? color = '#A4D233'
        : (valor <= (humedadBase + 0.5)) ? color = '#F9E547'
          : color = '#EE5340'
      return color
    }

    if (lecturaAnalisisSonda && lecturaAnalisisSonda.Mediciones) {
      var valoresSonda = [[
        'Medición',
        'ValorHumedadI',
        { role: 'style' },
        { calc: 'stringify', sourceColumn: 1, type: 'string', role: 'annotation' },
        'ValorHumedadM',
        { role: 'style' },
        { calc: 'stringify', sourceColumn: 1, type: 'string', role: 'annotation' },
        'ValorHumedadS',
        { role: 'style' },
        { calc: 'stringify', sourceColumn: 1, type: 'string', role: 'annotation' }
      ], ...generarDataAnalisis(lecturaAnalisisSonda)
      ]
    }

    const submitProceso = () => {
      if (modoIngreso === 'R') {
        confirmAlert({
          title: 'Atención',
          message: 'El modo rechazo generará automáticamente un rechazo en ARCA al presionar el botón Finalizar.',
          buttons: [
            {
              label: 'Continuar, estoy de acuerdo...',
              onClick: () => handleSubmit()
            },
            {
              label: 'Volver',
              onClick: () => null
            }
          ]
        })
      } else {
        handleSubmit()
      }
    }

    const mesgerror = (caladoSaveResponse && caladoSaveResponse.error) ? mensajeUsuario(caladoSaveResponse.message) : null
    const mesgextraerror = (caladoSaveResponse && caladoSaveResponse.error) ? mensajeContexto(caladoSaveResponse.message) : null
    const mesg = (caladoSaveResponse && caladoSaveResponse.data && caladoSaveResponse.data.length > 0) ? caladoSaveResponse.data[0].rechazarctg : null

    return (
      <>
        <div>
          <StatusModal
            show={caladoShowSaveModal}
            onClick={this.hideValidacionModal}
            message={mesg}
            errorMessage={mesgerror}
            extraErrorMessage={mesgextraerror}
          />

          { cpeEnPreingreso1 && cpe.calleDeIngreso === 2 && <h5 style={{ padding: '5px' }} >Carta de porte leida en la calle 1 : <b>{cpeEnPreingreso1.numero} - {cpeEnPreingreso1.cereal}</b></h5> }
          { cpeEnPreingreso2 && cpe.calleDeIngreso === 1 && <h5 style={{ padding: '5px' }} >Carta de porte leida en la calle 2 : <b>{cpeEnPreingreso2.numero} - {cpeEnPreingreso2.cereal}</b></h5> }
          { cpeEnPreingreso4 && cpe.calleDeIngreso === 3 && <h5 style={{ padding: '5px' }} >Carta de porte leida en la calle 4 : <b>{cpeEnPreingreso4.numero} - {cpeEnPreingreso4.cereal}</b></h5> }
          { cpeEnPreingreso3 && cpe.calleDeIngreso === 4 && <h5 style={{ padding: '5px' }} >Carta de porte leida en la calle 3 : <b>{cpeEnPreingreso3.numero} - {cpeEnPreingreso3.cereal}</b></h5> }

          <div md={10} style={{ marginBottom: '2%' }}>
            <CpaInfo cpa={cpa} cpe={cpe} openDialogPdf={this.props.openDialogPdf} />
          </div>

          <CamposProcesoCalado1
            onCondicionChange={this.handleCondicionChange}
            openDialogKeyboard={openDialogKeyboard}
            data={data}
            calificacionCalles={calificacionPorCalleCalado}
            valoresSonda={valoresSonda}
            maxH={maxH}
            cea={cea}
            cpa={cpa}
            minH={minH}
            avgH={avgH}
            onPrev={onPrev}
          />
        </div>

        <div className='justify-content-center container-submit-calado'>
          <Button
            onClick={onPrev}
            size='medium'
            variant='contained'
            style={{ outline: 'none', margin: '0 5% 0 0', backgroundColor: COLORES.grey.dark, color: '#ffffff' }}
          >
          Atras
          </Button>

          <Button
            onClick={submitProceso}
            size='medium'
            variant='contained'
            color='primary'
            style={{ outline: 'none', margin: '0 5% 0 0' }}
          >
          Finalizar
          </Button>
        </div></>
    )
  }
}

const getInitialValues = (state) => {
  const caladoCheckboxes = []

  let [
    rechazoAdministrativoCalado, fumigado, rechazoEnPesado, estadoCalificacion,
    claveCalificacionCereal, claveCalificacionCerealDos, cartaDePorteAutomotor

  ] = [null, null, null, null, null, null, null, null]

  if (state.calado.consultaCea) {
    ({
      rechazoAdministrativoCalado, fumigado, rechazoEnPesado, estadoCalificacion,
      claveCalificacionCereal, claveCalificacionCerealDos, cartaDePorteAutomotor
    } = state.calado.consultaCea)
  }
  // humedad = humedad || state.cereal.cerealEspecie['limiteDeHumedad']
  if (rechazoAdministrativoCalado) caladoCheckboxes.push('pendienteAutorizar')
  if (fumigado) { caladoCheckboxes.push('fumigado') && caladoCheckboxes.push('siloAparte') }

  if (!rechazoEnPesado && estadoCalificacion !== 'R' &&
      cartaDePorteAutomotor) {
    caladoCheckboxes.push('anularAnalisis')
  }

  return {
    // humedad: Number(humedad) * 10,
    caladoCheckboxes: caladoCheckboxes,
    display: state.calado.displaySugerido,
    modoIngreso: estadoCalificacion || 'A',
    condicionIngreso: claveCalificacionCereal,
    condicionIngresoSegunda: claveCalificacionCerealDos,
    siloAparte: caladoCheckboxes.includes('siloAparte'),
    pendienteAutorizar: caladoCheckboxes.includes('pendienteAutorizar')
  }
}

const mapStateToProps = (state) => ({
  initialValues: getInitialValues(state),
  displaySugerido: state.calado.displaySugerido,
  cpa: state.camionesIngreso.consultaCpa,
  cea: state.calado.consultaCea || {},
  cpe: state.calado.cpe,
  cerealEspecie: state.cereal.cerealEspecie,
  caladoShowSaveModal: state.calado.caladoShowSaveModal,
  caladoSaveResponse: state.calado.caladoSaveResponse,
  estadoOcupacionCallesCalado: state.calado.estadoOcupacionCallesCalado,
  calificacionPorCalleCalado: state.calado.calificacionPorCalleCalado,
  lecturaAnalisisSonda: state.calado.lecturaAnalisisSonda,
  puestoCalado: state.calado.puestoCalado,
  invalid: isInvalid(FORM_PROCESO_CALADO)(state),
  modoIngreso: selector(state, 'modoIngreso'),
  siloAparte: selector(state, 'siloAparte') ? selector(state, 'siloAparte') : state.calado.siloAparte,
  numero: selector(state, 'numero'),
  pendienteAutorizar: (selector(state, 'pendienteAutorizar')) ? selector(state, 'pendienteAutorizar') : state.calado.pendienteAutorizar,
  condicionIngresoSegunda: (selector(state, 'claveCalificacionCereal2')) ? selector(state, 'claveClasificacionCereal2') : state.calado.condicionIngresoSegunda,
  humedad: (state.calado.consultaCea) ? Number(state.calado.consultaCea.humedad) * 10 : state.cereal.cerealEspecie['limiteDeHumedad'] * 10,
  showCalado: state.utils.showCalado,
  cpeEnPreingreso1: state.calado.cpeEnPreingreso1,
  cpeEnPreingreso2: state.calado.cpeEnPreingreso2,
  cpeEnPreingreso3: state.calado.cpeEnPreingreso3,
  cpeEnPreingreso4: state.calado.cpeEnPreingreso4,
  isOpenBarchar: state.calado.isOpenBarchar
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PROCESO_CALADO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(ProcesoCalado1))
